import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import { Link } from "react-router-dom";

import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const DeliveryNote_inward = () => {
  useAuthRedirect();
  const [data, setData] = useState([]);
  const branch = localStorage.getItem("branch");
  const [loading, setLoading] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
      const [currentPage, setCurrentPage] = useState(1);
      const [itemsPerPage] = useState(10);
      const [searchTerm, setSearchTerm] = useState("");

      const canEntry = hasPermission("Delivery Note Inward", "entry");
      const canView = hasPermission("Delivery Note Inward", "view");


  // Fetch filtered data when branch is selected
  useEffect(() => {
      setLoading(true);
      axios.get(`https://rfs2.infraconsoft.net.in/api/deliveryNoteInward_list?branch=${branch}`)
      .then((response) => {
        setData(response.data.deliveryNoteInward);
        setFilteredData(response.data.deliveryNoteInward);
      })
      .catch((error) => {
        console.error("Error fetching vehicles:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [branch]); 

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Calculate indexes for pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);


  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);

    if (term === "") {
        setFilteredData(data);
        return;
    }

    const filtered = data.filter((item) => 
        String(item.del_no || "").toLowerCase().includes(term)
    );

    setFilteredData(filtered);
};
if (!canView) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }


  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
          
          <h2 className="add-txt">delivery Note Inward</h2>
          <Time />
        </section>

        <div className="search-filter">
          <p>Search: </p>
          <input type="text" placeholder="Search by Delivery No" value={searchTerm} onChange={handleSearch} className="search-input" />
        </div>

        <div className="content-table">
          <table>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Delivery No</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
  {loading ? (
    <tr>
      <td colSpan="6" className="loading-text">Loading data, please wait...</td>
    </tr>
  ) : currentData.length > 0 ? (
    currentData.map((item, index) => (
      <tr key={index}>
        <td>{indexOfFirstItem + index + 1}</td>
        <td>
  {canEntry ? (
    <Link to={`/inventory/deliverynoteinward_in/${item.del_no}`}>
      {item.del_no}
    </Link>
  ) : canView ? (
    item.del_no
  ) : (
    "-"
  )}
</td>

        <td>{item.del_date ? new Date(item.del_date).toLocaleDateString('en-GB') : "N/A"}</td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="6">No Data Available</td>
    </tr>
  )}
</tbody>

          </table>
        </div>

        <div className="pagination">
          <button onClick={() => paginate(currentPage - 1)}  disabled={currentPage === 1}>Previous</button>
          {[...Array(Math.ceil(filteredData.length / itemsPerPage))].map((_, index) => (
            <button key={index} onClick={() => paginate(index + 1)} className={currentPage === index + 1 ? 'active' : ''}>{index + 1}</button>
          ))}
          <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === Math.ceil(filteredData.length / itemsPerPage)}>Next</button>
        </div>
      </div>
    </div>
  );
};

export default DeliveryNote_inward;
